import { render, staticRenderFns } from "./StatsLayout.vue?vue&type=template&id=49902c71&"
import script from "./StatsLayout.vue?vue&type=script&lang=js&"
export * from "./StatsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports